import { render, staticRenderFns } from "./AlertManager.vue?vue&type=template&id=46ac0384"
import script from "./AlertManager.vue?vue&type=script&lang=js"
export * from "./AlertManager.vue?vue&type=script&lang=js"
import style0 from "./AlertManager.vue?vue&type=style&index=0&id=46ac0384&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports